/*
* Override search function to return more results
* */
document.addEventListener('DOMContentLoaded', function () {

    let PreductiveSearchCustomElement = window.customElements.get('predictive-search-element');

    PreductiveSearchCustomElement.prototype.getSearchResults = async function(t){

        this.abort_controller && this.abort_controller.abort();
        var e = t.trim();
        if (this.cached_results[e]) this.results.innerHTML = this.cached_results[e]; else {
            this.abort_controller = new AbortController, this.toggleLoading(!0);
            try {
                var i = await fetch(`${Shopify.routes.predictive_search}?q=${encodeURIComponent(t)}&section_id=predictive-search&resources[limit]=8&resources[limit_scope]=each`, {signal: this.abort_controller.signal});
                if (!i.ok) throw new Error(i.status);
                var s = (await i.text()).parse().innerHTML;
                this.cached_results[e] = s, this.results.innerHTML = s
            } catch {
            }
        }
    }

});

document.addEventListener('DOMContentLoaded', function () {

    window.addEventListener('theme:cart:updated', function (e) {

        const cartElement = e.detail;

        const isProductTemplate = document.body.classList.contains('template--product');

        const hasSubscriptionWidget = document.querySelector('.main-product--form recharge-subscription-widget') !== null;

        const isGroupedProduct = document.querySelector('.variant-quantities-wrapper') !== null;

        subItems = cartElement.querySelectorAll('.cart--item--selling-plan');

        // if the current product is sub product - then potentially disable adding it to cart

        // fetch the latest version of the cart - to ensure that the last delete/add action has completed

        fetch('/cart.js')

            .then(response => response.json())

            .then(shopifyCart => {

                // Handle updated shopifyCart data

                if (isProductTemplate && hasSubscriptionWidget && !isGroupedProduct) {

                    // get all the product-buy-buttons-element elements and work out if that product is in the cart already

                    // - if it is then dsable the add to basket

                    document.querySelectorAll('product-buy-buttons-element').forEach(button => {

                        const productId = button.closest('form').dataset.productid;

                        const idsInCart = shopifyCart.items.map(item => item.product_id.toString() );

                        if (idsInCart.includes( productId ) && ! isGroupedProduct){

                            button.querySelector('button').disabled = true;

                            button.querySelector('span').innerText = 'Already in basket';

                        }else{

                            button.querySelector('button').removeAttribute('disabled');

                            button.querySelector('span').innerText = 'Add to basket';

                        }

                    });

                    // limit subs to 1 total

                    // if ( shopifyCart.item_count > 0 && subItems.length > 0) {

                    //

                    //     //disable the add to basket

                    //     document.querySelectorAll('product-buy-buttons-element button').forEach(button => {

                    //         button.disabled = true;

                    //         button.querySelector('span').innerText = 'Already in basket';

                    //     });

                    // }else{

                    //     //enable the add to basket

                    //     document.querySelectorAll('product-buy-buttons-element button').forEach(button => {

                    //         button.removeAttribute('disabled');

                    //         button.querySelector('span').innerText = 'Add to basket';

                    //     });

                    // }

                }

            });

    });

});

customElements.whenDefined('shopify-forms-embed').then(() => {
  const observer = new MutationObserver(() => {
    const widget = document.querySelector('shopify-forms-embed');

    if (widget) {
        observer.disconnect();

        const shadowRoot = widget.shadowRoot;
        const sheet = new CSSStyleSheet();

        sheet.replaceSync(`
            #form-container-ref :is(input[type="text"], input[type="email"], input[type="tel"], textarea, button[type="button"]) {
                font-family: var(--font--nav--family);
                font-size: 16px;
                border-radius: 25px;
                box-shadow: 0 0 0 1px rgb(148, 149, 150);
            }
            #form-container-ref :is(input[type="text"], input[type="email"], input[type="tel"], textarea, button[type="button"]):hover {
                box-shadow: 0 0 0 1px #000;
            }
            #form-container-ref :is(input[type="text"], input[type="email"], input[type="tel"], textarea, button[type="button"]):focus-visible {
                outline: 2px solid #000;
            }
            #form-container-ref [class*="textBody_"] {
                font-family: var(--font--nav--family);
                text-align: left;
                text-transform: uppercase;
                font-size: 14px;
                font-weight: 700;
            }
            #form-container-ref button[type="submit"] {
                font-family: var(--font--nav--family);
                text-transform: uppercase;
                font-size: 14px;
                font-weight: var(--font--nav--weight);
                border: 2px solid var(--button--bg-color);
                border-radius: var(--button--radius);
                line-height: 45px;
                padding: 0 var(--spacing--3);
                width: fit-content;
                height: 45px;
            }
            #form-container-ref form > div:first-child :is(input, textarea) {
                margin-top: 1px;
            }
            #form-container-ref [class*="formFieldContainer_"]:has(textarea)::before {
                background: transparent;
            }
        `);

        shadowRoot.adoptedStyleSheets.push(sheet);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
